import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

const NavMenu = () => {
  return (
    <>
      <Navbar className="navbar shadow" expand="lg">
        <Container>
          <Navbar.Brand href="#home">
            <img src="images/logo.png" className="logo" alt="logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto">
              <Nav.Link href="#home" className="me-3 navitem">
                Home
              </Nav.Link>
              <Nav.Link href="#link" className="me-3 navitem">
                About Us
              </Nav.Link>
              <Nav.Link href="#link" className=" navitem">
                Why The Code Pilot
              </Nav.Link>
            </Nav>
            <Nav className="">
              <a href="/" className="btn--base">
                Talk to an expert
              </a>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default NavMenu;
